import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export function PilatesFooter() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <footer id="contact" className="border-t border-padel-muted bg-padel-dark px-4 py-16 text-center" data-id="element-189" data-mp="drc47gplqfu6">
      <div className="mx-auto max-w-3xl" data-id="element-190" data-mp="hsxdks2xgbzm">
        <h2 className="font-display text-3xl font-black text-white sm:text-4xl" data-id="element-191" data-mp="hrm8moxqwy6x">
          ¿Vas a seguir "zafando" o vas a crecer?
        </h2>
        <p className="mt-6 text-lg leading-relaxed text-gray-300" data-id="element-192" data-mp="8tkach5ecjnc">
          Si después de leer esto decidís no comprar, está perfecto. Pero el
          lunes cuando estés en la cancha, sin saber qué ejercicio dar y viendo
          cómo tus alumnos se aburren... acordate que la solución estaba a un
          click de distancia.
        </p>

        <button onClick={scrollToPricing} className="mx-auto mt-10 flex w-full max-w-md items-center justify-center gap-2 rounded-xl bg-padel-lime px-6 py-4 font-display text-lg font-black text-padel-dark shadow-[0_0_30px_rgba(197,255,61,0.2)] transition-transform hover:scale-[1.02] active:scale-[0.99] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-padel-lime focus-visible:ring-offset-2 focus-visible:ring-offset-padel-dark sm:text-xl" data-id="element-193" data-mp="1p5fv2e0w7nv0">
          DAME EL ACCESO AL MÉTODO PRO-PÁDEL
          <ChevronRightIcon className="h-6 w-6" strokeWidth={3} data-id="element-194" data-mp="1ddy0qa1fs06i" />
        </button>
      </div>

      <div className="mx-auto mt-20 max-w-lg border-t border-padel-muted pt-10" data-id="element-195" data-mp="18fcv1v3f0oao">
        <p className="font-display text-2xl font-black text-white" data-id="element-196" data-mp="18hhb1bel9drb">
          💪 STOCK DIGITAL™
        </p>
        <p className="mt-3 text-gray-400" data-id="element-197" data-mp="1idal8o4u4v5x">
          El sistema completo para profes de pádel que quieren trabajar con más
          orden, evidencia y libertad.
        </p>
        <p className="mt-2 text-sm text-gray-500" data-id="element-198" data-mp="2ytn86qoapld3">
          Porque enseñar pádel no debería costarte todos los domingos del año.
        </p>
        <div className="mt-6 flex justify-center gap-4 text-sm text-gray-400" data-id="element-199" data-mp="30w5p1ztlo2cz">
          <span data-id="element-200" data-mp="35uqp9z8uqm1f">📧 atencion.verticedigital@gmail.com</span>
          <span data-id="element-201" data-mp="35t5xghdx9h79">•</span>
          <span data-id="element-202" data-mp="35wtnh6k5rlh8">🌐 www.verticedigital.store</span>
        </div>
        <p className="mt-8 text-xs text-gray-600" data-id="element-203" data-mp="3av517sdkqg4q">
          © Stock Digital™ 2026 — Todos los derechos reservados.
          <br data-id="element-204" data-mp="3fs57o4ec5kwd" />
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}